import React from 'react'

export function Conditional({cond, render}) {
    return cond() ? render() : null;
}
